import React from 'react';
import {Glyphs, TscButtonType, PopoverButton, TscPopoverOrigin} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';
import {useTranslation} from 'react-i18next';

const CommentFilterSettingsBase: React.FC<ICommentFilterSettingsProps> = ({menu}) => {
   const {t} = useTranslation();

   return (
      <PopoverButton
         buttonGlyph={<Glyphs.EllipsisStacked16x16 />}
         origin={TscPopoverOrigin.bottomRight}
         showArrow={false}
         buttonTitle={t('conversations.conversationSettings')}
         buttonType={TscButtonType.tertiary}
         popoverMenu={menu}
         useMobileMenu={false}
         closeMenuOnClick={true}
         popoverMenuMaxHeight={cssConstants.contextMenuMaxHeight}
         popoverMenuMaxWidth="100%"
         testId="comment-filter-settings"
         width={cssConstants.glyphButtonWidth}
         style={{zIndex: cssConstants.zIndex.commentSettingsMenu}}
      />
   );
};

export interface ICommentFilterSettingsProps {
   menu: React.ReactNode;
}

export default CommentFilterSettingsBase;